import { useOnboardingMachine } from '../components/machine-provider';

export default useOnboardingMachine;
